import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './style.scss';


const Password = ({ preicon = true, bottomOnly = false, customClass = '', actionStyle = {}, postIcon = true, ...rest }) => {
    const [type, setType] = useState('password');
    const [focused, setFocused] = useState(false);

    const { value } = { ...rest };

    const toggleType = (e) => {
        e.preventDefault();

        if (type == 'text') {
            setType('password');
        } else {
            setType('text');
        }
    };

    return <div
        style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
    >
        <div
            className={`${bottomOnly ? 'password-bottom ' : 'password '}${focused && bottomOnly ? 'password-bottom-focused ' : ''}input-group mb-3${!preicon ? ' no-preicon' : ''}`}
        >
            {/* {preicon && <div className="password__preicon input-group-prepend">
                <span className="input-group-text">
                    <FontAwesomeIcon
                        icon={["fas", "lock"]}
                    />
                </span>
            </div>} */}
            <input
                type={type}
                className={`password__field form-control${preicon ? ' password__field-preicon' : ''} ${customClass}`}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                {...rest}
            />
            {
                postIcon && <div className="password__posticon input-group-append">
                    <span
                        // className="password__action input-group-text"
                        className={`password__action input-group-text ${customClass}`}
                        onClick={toggleType}
                        style={actionStyle}
                    >
                        <FontAwesomeIcon
                            icon={["fas", type == 'password' ? 'eye-slash' : 'eye']}
                        />
                    </span>
                </div>
            }
        </div>
    </div>;
};

export default Password;